import { GLOBAL_IMAGES } from "../../assets/asset";

export default function ExitScreenModal({ navigate, onClose }) {
  return (
    <div className="absolute font-mali flex items-center justify-center  h-screen w-screen bg-black/50 z-40">
      <div className="container flex flex-col items-center justify-center w-full ">
        <img src={GLOBAL_IMAGES.trouble} className="h-96 w-auto" alt="" />
        <div className="flex gap-8 items-center-justify-center">
          <button
            onClick={() => navigate(-1)}
            className="text-white text-2xl font-bold rounded-lg ring-4 ring-primary-dark-blue border-yellow-500 border-4 bg-[#91181d] p-2 px-8"
          >
            Yes
          </button>
          <button onClick={(onClose)} className="text-white text-2xl font-bold rounded-lg ring-4 ring-primary-dark-blue border-yellow-500 border-4 bg-[#91181d] p-2 px-8">
            No
          </button>
        </div>
      </div>
    </div>
  );
}
